module.exports = {"en-US":{"components":{"paginator":{"first":"","prev":"","next":"","last":""}}}}